// RevoltCheckbox — square toggle matching RevoltSwitch glass / red accent styling
import './RevoltCheckbox.css';

export function RevoltCheckbox({
  checked = false,
  onChange,
  label,
  children,
  disabled = false,
  className = '',
  id,
  ariaLabel,
  radius = 6,
}) {
  const radiusValue = typeof radius === 'number' ? `${radius}px` : radius;

  const handleChange = (event) => {
    if (disabled) return;
    onChange?.(event.target.checked);
  };

  const classes = [
    'revolt-checkbox',
    disabled ? 'is-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const labelContent = children ?? label;

  return (
    <label className={classes} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <span
        className="revolt-checkbox-box"
        style={{ borderRadius: radiusValue }}
        aria-hidden
      >
        <i className="fa-solid fa-check revolt-checkbox-icon" />
      </span>
      {labelContent != null && labelContent !== false && (
        <span className="revolt-checkbox-label">{labelContent}</span>
      )}
    </label>
  );
}
